import React, { Children, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutFetch, RootState, selectMobileDeviceState, selectUserLoggedIn } from '../../modules';
import {
    CalendarOutlined,
    CloseOutlined,
    DollarOutlined,
    HighlightOutlined,
    HomeOutlined,
    LineChartOutlined,
    MenuOutlined,
    NotificationOutlined,
    QuestionOutlined,
    RocketOutlined,
    SettingOutlined,
    StockOutlined,
    UserAddOutlined,
    UserDeleteOutlined,
    UserOutlined,
    CaretDownOutlined,
} from '@ant-design/icons';
import Logo from '../../assets/images/icon.png';
import { useHistory, useLocation } from 'react-router';
import { Divider, Menu, Button, Tooltip } from 'antd';
import { Props } from 'react-select';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { Notification } from '../Notification';

export const HeaderComponent: React.FC<Props> = () => {
    const isMobile = useSelector(selectMobileDeviceState);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const history = useHistory();

    const redirect = (to: string) => {
        history.push(to);
    };
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const isLogin = useSelector((state: RootState) => selectUserLoggedIn(state));
    const location = useLocation();
    const isOnPriceBoardPage = location.pathname.includes('/priceboard');
    const isOnLandingPage = location.pathname === '/';
    const dispatch = useDispatch();
    const items = [
        {
            key: '/priceboard',
            label: <span data-tour="trading-menu">Trading</span>,
            onClick: () => redirect('/priceboard'),
        },
        {
            key: '/rank',
            label: <span data-tour="contest-menu">Contest</span>,
            onClick: () => redirect('/rank'),
        },
        // {
        //     key: '/company',
        //     label: <span data-tour="news-menu">News</span>,
        //     onClick: () => redirect('/company'),
        // },
        {
            key: '/event',
            label: <span data-tour="event-menu">Announcements</span>,
            onClick: () => redirect('/event'),
        },
        {
            key: '/rule',
            label: 'Q&A',
            onClick: () => redirect('/rule'),
        },
        {
            key: 'guidelines',
            label: <span>Guidelines</span>,
            onClick: () =>
                window.open(
                    'https://docs.google.com/document/d/1f_GkbNqD0HrH7LhEPpdq0TVqrq4PkImK/edit?usp=sharing&ouid=113864504819983791772&rtpof=true&sd=true',
                ),
        },
    ].filter(Boolean);
    const mobileItems = [
        {
            key: '/',
            label: 'Home',
            icon: <HomeOutlined />,
            onClick: () => redirect('/'),
        },
        {
            key: '/priceboard',
            label: 'Trading',
            icon: <LineChartOutlined />,
            className: 'menu-vertical',
            onClick: () => redirect('/priceboard'),
        },
        {
            key: '/rank',
            icon: <RocketOutlined />,
            label: 'Contest',
            onClick: () => redirect('/rank'),
        },
        {
            key: '/rule',
            label: 'Q&A',
            icon: <QuestionOutlined />,
            onClick: () => redirect('/rule'),
        },
        // {
        //     key: '/company',
        //     label: 'Stock News',
        //     icon: <HighlightOutlined />,
        //     onClick: () => redirect('/company'),
        // },
        {
            key: '/event',
            label: 'Platform News',
            icon: <CalendarOutlined />,
            onClick: () => redirect('/event'),
        },
        !isLogin && {
            key: '/signin',
            label: 'Login',
            icon: <UserOutlined />,
            onClick: () => redirect('/signin'),
        },
        !isLogin && {
            key: '/signup',
            label: 'Register',
            icon: <UserAddOutlined />,
            onClick: () => redirect('/signup'),
        },

        isLogin && {
            key: 'profile',
            label: 'Profile',
            className: 'menu-vertical',
            icon: <SettingOutlined />,
            children: [
                {
                    key: 'profile-assets',
                    label: (
                        <div className="sub-item-vertical">
                            <UserOutlined style={{ marginRight: '5px' }} />
                            <a href="/profile/assets" rel="noopener noreferrer">
                                Assets
                            </a>
                        </div>
                    ),
                },
                {
                    key: 'profile-notifications',
                    label: (
                        <div className="sub-item-vertical">
                            <NotificationOutlined style={{ marginRight: '5px' }} />
                            <a href="/profile/notifications" rel="noopener noreferrer">
                                Notifications
                            </a>
                        </div>
                    ),
                },
            ],
        },
        isLogin && {
            key: 'Log out',
            icon: <UserDeleteOutlined />,
            className: `item-action item-action-mobile`,

            label: <div className="item-action-content">Log out</div>,
            onClick: () => handleLogout(),
        },
    ].filter(Boolean);
    const handleLogout = () => {
        dispatch(logoutFetch());
        history.push('/');
    };

    const handleStartTour = () => {
        // Reset tour states and reload to trigger tour prompt
        localStorage.removeItem('website_tour_permanently_skipped');
        window.location.reload();
    };
    return isMobile ? (
        <header className={'mobile-landing-page__header'}>
            <div className="mobile-landing-page__header___top">
                <MenuOutlined className="mobile-landing-page__header___top____menu-icon" onClick={toggleMenu} />

                <div className="mobile-landing-page__header___top____logo">
                    <img src={Logo} alt="Logo" onClick={() => redirect('/')} />
                </div>
            </div>
            <div className="pg__header___right">
                <nav className={`mobile-landing-page__header___nav ${isMenuOpen ? 'open' : ''}`}>
                    <div style={{ padding: '8px 16px' }} onClick={toggleMenu}>
                        <CloseOutlined style={{ fontSize: 16 }} />
                    </div>
                    <Menu
                        mode="inline"
                        items={mobileItems}
                        style={{ border: 'none', background: 'transparent' }}
                        className={'mobile-landing-page__header___nav____menu'}
                        selectedKeys={[location.pathname]}
                    />
                    <Divider style={{ borderColor: '#ccc' }} />
                </nav>
            </div>
        </header>
    ) : (
        <header
            className={
                'pg__header' +
                (isOnPriceBoardPage ? ' header-price-board' : isOnLandingPage ? ' header-landing-page' : '')
            }>
            <div className="pg__header___right">
                <img src={Logo} alt="Logo" onClick={() => redirect('/')} />
                <nav>
                    <Menu
                        overflowedIndicator={
                            <div className="pg__header___right____more-menu">
                                More <CaretDownOutlined />
                            </div>
                        }
                        mode={'horizontal'}
                        items={items}
                        style={{ border: 'none', background: 'transparent' }}
                        selectedKeys={[location.pathname]}
                    />
                </nav>
            </div>
            <div className="pg__header___auth">
                {!isLogin && (
                    <div className={'pg__header___auth'}>
                        <div className={'pg__header___auth____btn-1'} onClick={() => redirect('/signin')}>
                            Login
                        </div>
                        <div className={'pg__header___auth____btn-2'} onClick={() => redirect('/signup')}>
                            <span className="register-icon"></span>
                            Register
                        </div>
                    </div>
                )}
                {isLogin && (
                    <div className="d-flex justify-center align-items-center">
                        <div
                            className="pg__header___auth____login"
                            onClick={() => redirect('/profile/assets')}
                            data-tour="user-profile">
                            <div>
                                <UserOutlined />
                            </div>
                            <p>My Profile</p>
                        </div>
                        <div style={{ marginRight: '20px', marginLeft: '20px' }}>
                            <Notification placement="bottomLeft" />
                        </div>
                        <Tooltip title="Start Platform Tour">
                            <Button
                                type="text"
                                icon={<QuestionOutlined />}
                                onClick={handleStartTour}
                                style={{ color: 'var(--primary-text-color)' }}
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
        </header>
    );
};
export const Header = compose(injectIntl)(HeaderComponent) as unknown as React.ComponentClass;
